import { useQuery } from "@tanstack/react-query";
import { CommonApi } from "service/api/common.api";
import { QUERY_KEYS } from "service/constant/query-keys";

export const useGetListProvince = (params, options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.PROVINCE_LIST, params],
    queryFn: async () => {
      const res = await CommonApi.getListProvince(params);
      return res.data;
    },
    staleTime: Infinity,
    gcTime: Infinity,
    ...options,
  });
};

export const useGetListProvinceType = (params, options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.PROVINCE_TYPE_LIST, params],
    queryFn: async () => {
      const res = await CommonApi.getListProvinceType(params);
      return res.data?.data;
    },
    staleTime: Infinity,
    gcTime: Infinity,
    ...options,
  });
};

export const useGetListContactCenter = (params, options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.CONTACT_CENTER_LIST, params],
    queryFn: async () => {
      const res = await CommonApi.getListContactCenter(params);
      return res.data;
    },
    staleTime: Infinity,
    gcTime: Infinity,
    ...options,
  });
};

export const useGetListCityPostOffice = (params, options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.CITY_POST_OFFICE_LIST, params],
    queryFn: async () => {
      const res = await CommonApi.getCityPostOffice(params);
      return res.data;
    },
    staleTime: Infinity,
    gcTime: Infinity,
    ...options,
  });
};

export const useGetListDistrictPostOffice = (params, options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.DISTRICT_POST_OFFICE_LIST, params],
    queryFn: async () => {
      const res = await CommonApi.getListDistrictPostOffice(params);
      return res.data;
    },
    staleTime: Infinity,
    gcTime: Infinity,
    ...options,
  });
};
